import { createSlice } from "@reduxjs/toolkit";

const quoteItemsInitial = [{ description: "", price: 10, quantity: 1 }];

const initialDueDate = new Date();
initialDueDate.setDate(initialDueDate.getDate() + 30);

const initialState = {
  chat: [],
  chatId: null,
  recipient: null,
  quoteItems: quoteItemsInitial,
  dueDate: initialDueDate.getTime(),
  selectedDueDate: "30",
  customId: "",
};

export const chatSlice = createSlice({
  name: "chat",
  initialState,
  reducers: {
    setChat: (state, actions) => {
      state.chat = actions.payload;
    },
    setChatId: (state, actions) => {
      state.chatId = actions.payload;
    },
    setRecipient: (state, actions) => {
      state.recipient = actions.payload;
    },
    addQuoteItem: (state) => {
      state.quoteItems.push({ description: "", price: 10, quantity: 1 });
    },
    removeQuoteItem: (state, actions) => {
      state.quoteItems = state.quoteItems.filter(
        (item, index) => index !== actions.payload
      );
    },
    editQuoteItemDescription: (state, actions) => {
      state.quoteItems[actions.payload.index].description =
        actions.payload.description;
    },
    editQuoteItemPrice: (state, actions) => {
      state.quoteItems[actions.payload.index].price = parseFloat(
        actions.payload.price
      );
    },
    editQuoteItemQuantity: (state, actions) => {
      state.quoteItems[actions.payload.index].quantity = parseInt(
        actions.payload.quantity
      );
    },
    editQuoteDueDate: (state, actions) => {
      const date = new Date();
      date.setDate(date.getDate() + actions.payload);
      state.dueDate = date.getTime();
      state.selectedDueDate = String(actions.payload);
    },
    editQuoteCustomId: (state, actions) => {
      state.customId = actions.payload;
    },
    resetQuoteItems: (state) => {
      state.quoteItems = quoteItemsInitial;
      state.customId = "";
      state.dueDate = initialDueDate.getTime();
      state.selectedDueDate = "30";
    },
  },
});

export const {
  setChat,
  setChatId,
  setRecipient,
  addQuoteItem,
  removeQuoteItem,
  editQuoteItemDescription,
  editQuoteItemPrice,
  editQuoteItemQuantity,
  editQuoteDueDate,
  editQuoteCustomId,
  resetQuoteItems,
} = chatSlice.actions;
export default chatSlice.reducer;
